const Logo = () => {
  return (
    <img
      src="/images/PHUWADOL-LOGO.svg"
      alt="PHUWADOL Logo"
      style={{
        width: "auto",
        height: "72px",
      }}
    />
  );
};

export default Logo;
